module.exports = __webpack_public_path__ + "img/rental-car-service.73a8ec03.png";